import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Glyphicon, Label } from 'reaxl';

/**
 *  Renders a fueltype badge for use in InventoryListingBadges
 */
function FuelTypeBadge(_ref) {
  let {
    engineName,
    fuelGroup,
    fuelName
  } = _ref;
  let label = '';
  let glyph = '';
  if (fuelName === 'Hybrid Gas/Electric' && engineName === 'Plug-in Hybrid' || fuelGroup === 'Plug-in Hybrid: Gas/Electric' && engineName === 'Hybrid') {
    label = 'Plug-In Hybrid';
    glyph = 'plugin-hybrid';
  }
  if (fuelName === 'Hybrid Gas/Electric' && engineName === 'Gas / Electric Hybrid' || fuelGroup === 'Hybrid: Gas/Electric' && engineName === 'Hybrid') {
    label = 'Hybrid';
    glyph = 'hybrid';
  }
  if (fuelName === 'Electric' && engineName === 'Electric' || fuelGroup === 'Electric' && engineName === 'Electric') {
    label = 'Electric';
    glyph = 'electric';
  }
  if (!label) return null;
  return /*#__PURE__*/_jsx(Label, {
    bsStyle: "info-inverse",
    className: "display-inline-flex gap-1",
    "data-cmp": "fuelTypeIcon"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: glyph
  }), label);
}
export default FuelTypeBadge;